import {
  ResponseData,
  SnakeCasedFilters,
} from '@javascript/types/SeoPageTypes';

const generateQueryString = (params: SnakeCasedFilters) => {
  const queryString = Object.entries(params).reduce((query, [key, value]) => {
    if (value === null || value === '') return query;

    const encodedValue = encodeURIComponent(String(value));
    return query ? `${query}&${key}=${encodedValue}` : `${key}=${encodedValue}`;
  }, '');

  return queryString;
};

const requestVehicleSearchCount = async (
  queryParams: string
): Promise<ResponseData> => {
  const response = await fetch(`/vehicles.json?${queryParams}`);

  if (!response.ok) {
    throw new Error(`Failed to fetch: ${response.statusText}`);
  }

  return response.json();
};

export { requestVehicleSearchCount, generateQueryString };
